(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("moment"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "moment", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["choerodon-ui-pro-with-locales"] = factory(require("mobx"), require("moment"), require("react"), require("react-dom"));
	else
		root["choerodon-ui-pro-with-locales"] = factory(root["mobx"], root["moment"], root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mobx__, __WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 